import _ from 'lodash'
import { Map, Record } from 'immutable'

import { SET_CAROUSEL_POSITION } from './constants'

const CarouselRecord = new Record({
    position: 0,
})

export default (state = Map(), action = {}) => {
    switch (action.type) {
        case SET_CAROUSEL_POSITION: {
            const id = _.get(action, 'data.id', null)
            const position = _.get(action, 'data.position', 0)

            if (!id) return state

            return state.set(id, new CarouselRecord({ position }))
        }
        default:
            return state
    }
}
